<template>
  <div class="loadingContainer">
    <div class="loadingMainContainer">
      <img class="loadingBacloding" src="../assets/name_loading.gif" ref="loading" />
      <img class="loadingBacText" src="../assets/nameing.png" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'nameloading',
  mounted () {
  }
}
</script>
<style scoped>
.loadingContainer{
  width: 100%;
  height: 100%;
  background: #f3ebe2;
  margin: 0 auto;
}
.loadingMainContainer{
  width: 7.5rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-3.75rem, -1.2rem);
}
.loadingMainContainer img{
  display: block;
}
.loadingBacloding{
  width: 7.5rem;
  height: 2.17rem;
  margin-left:-0.4rem;
}
.loadingBacText{
  width: 1.6rem;
  height: 0.31rem;
  margin: 0 auto;
}
</style>

